webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CryptoCurrencyList__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Previous__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { CryptoCurrencyList: __WEBPACK_IMPORTED_MODULE_0__components_CryptoCurrencyList__["a" /* default */], Previous: __WEBPACK_IMPORTED_MODULE_1__components_Previous__["a" /* default */] },

  data: function data() {
    return {
      showError: false,
      loading: true,
      currencies: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://cryptotodayve.herokuapp.com/api/cryptos').then(function (cryptos) {
      _this.currencies = cryptos.data;
      _this.loading = false;
    }).catch(function (err) {
      _this.loading = false;
      _this.showError = true;
    });
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CryptoCurrency__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CryptoCurrencyList',
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__Loading__["a" /* default */], CryptoCurrency: __WEBPACK_IMPORTED_MODULE_0__CryptoCurrency__["a" /* default */] },
  props: {
    currencies: { type: Array },
    loading: { type: Boolean }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CryptoCurrency',
  props: {
    currency: { type: Object }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Loading"
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Previous',
  props: {
    previousCurrency: { type: Object }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(19);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatPrice', function (value) {
  var val = (value / 1).toFixed(2).replace('.', ',');
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3eb3ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(52);
function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f3eb3ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3eb3ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CryptoCurrencyList_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3ab468_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CryptoCurrencyList_vue__ = __webpack_require__(29);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CryptoCurrencyList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3ab468_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CryptoCurrencyList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CryptoCurrency_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216cf2cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CryptoCurrency_vue__ = __webpack_require__(25);
function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-216cf2cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CryptoCurrency_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216cf2cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CryptoCurrency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-list__item mdl-shadow--2dp"},[_c('span',{staticClass:"mdl-list__item-primary-content"},[_c('img',{attrs:{"src":_vm.currency.img,"width":"50","alt":_vm.currency.name}})]),_vm._v(" "),_c('div',{staticClass:"mdl-list__item-secondary-action"},[_c('ul',[_c('li',{staticClass:"title"},[_vm._v("1 "+_vm._s(_vm.currency.id))]),_vm._v(" "),_c('li',{staticClass:"amount"},[_vm._v("$ "+_vm._s(_vm.currency.usd))]),_vm._v(" "),_c('li',{staticClass:"amount"},[_vm._v("BsS "+_vm._s(_vm._f("formatPrice")(_vm.currency.bss)))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffd1f55_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(28);
function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ffd1f55"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffd1f55_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-spinner mdl-js-spinner mdl-spinner--single-color is-active"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('loading'):_c('div',{staticClass:"demo-list-action mdl-list"},_vm._l((_vm.currencies),function(currency){return _c('crypto-currency',{key:currency.id,attrs:{"currency":currency}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Previous_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d119b6f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Previous_vue__ = __webpack_require__(32);
function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d119b6f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Previous_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d119b6f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Previous_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Previous prices")]),_vm._v(" "),_c('div',{attrs:{"id":"first"}},[_c('h2',[_vm._v("Date: "+_vm._s(_vm.previousCurrency.yesterday.DATE))]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 BTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.yesterday.BTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DGB:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.yesterday.DGB)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 SC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.yesterday.SC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 ETH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.ETH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 LTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.LTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DASH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.DASH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 XRP:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.XRP)+" ")])]),_vm._v(" "),_c('div',{attrs:{"id":"second"}},[_c('h2',[_vm._v("Date: "+_vm._s(_vm.previousCurrency.twoDays.DATE))]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 BTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.twoDays.BTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DGB:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.twoDays.DGB)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 SC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.twoDays.SC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 ETH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.ETH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 LTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.LTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DASH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.DASH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 XRP:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.XRP)+" ")])]),_vm._v(" "),_c('div',{attrs:{"id":"third"}},[_c('h2',[_vm._v("Date: "+_vm._s(_vm.previousCurrency.threeDays.DATE))]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 BTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.threeDays.BTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DGB:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.threeDays.DGB)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 SC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.threeDays.SC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 ETH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.ETH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 LTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.LTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DASH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.DASH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 XRP:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.XRP)+" ")])]),_vm._v(" "),_c('div',{attrs:{"id":"fourth"}},[_c('h2',[_vm._v("Date: "+_vm._s(_vm.previousCurrency.fourDays.DATE))]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 BTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fourDays.BTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DGB:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fourDays.DGB)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 SC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fourDays.SC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 ETH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.ETH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 LTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.LTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DASH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.DASH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 XRP:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.XRP)+" ")])]),_vm._v(" "),_c('div',{attrs:{"id":"fifth"}},[_c('h2',[_vm._v("Date: "+_vm._s(_vm.previousCurrency.fiveDays.DATE))]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 BTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.BTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DGB:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.DGB)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 SC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.SC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 ETH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.ETH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 LTC:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.LTC)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 DASH:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.DASH)+" ")]),_vm._v(" "),_c('p',[_c('label',[_vm._v(" 1 XRP:")]),_vm._v(" "+_vm._s(_vm.previousCurrency.fiveDays.XRP)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-layout mdl-js-layout mdl-layout--fixed-header mdl-layout--fixed-tabs"},[_vm._m(0),_vm._v(" "),_c('main',{staticClass:"mdl-layout__content"},[_c('section',{staticClass:"mdl-layout__tab-panel is-active",attrs:{"id":"currencies"}},[_c('crypto-currency-list',{attrs:{"loading":_vm.loading,"currencies":_vm.currencies}}),_vm._v(" "),(_vm.showError)?_c('div',{staticClass:"mdl-js-snackbar mdl-snackbar mdl-snackbar--active",attrs:{"id":"demo-snackbar-example"}},[_c('div',{staticClass:"mdl-snackbar__text"},[_vm._v("\n                    Ocurrió un error consultando los datos\n                ")])]):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"mdl-layout__header"},[_c('div',{staticClass:"mdl-layout__header-row"},[_c('span',{staticClass:"mdl-layout-title"},[_vm._v("CryptoTodayVE")])]),_vm._v(" "),_c('div',{staticClass:"mdl-layout__tab-bar mdl-js-ripple-effect"},[_c('a',{staticClass:"mdl-layout__tab is-active",attrs:{"href":"#currencies"}},[_c('i',{staticClass:"fas fa-star fa-2x"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[15]);


// WEBPACK FOOTER //
// static/js/app.7399c0b12dd0076fc20e.js